"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnSearchStateChanges = exports.useSearchState = exports.withSearchStatePageContext = exports.getSearchStateFromProps = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const router_1 = require("next/router");
const react_1 = __importStar(require("react"));
const superjson_1 = require("superjson");
const libs_context_req_ctx_1 = require("@hotelplan/libs.context.req-ctx");
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
const SearchState_shared_1 = require("./SearchState.shared");
const SearchStateContext_1 = require("./SearchStateContext");
function getSearchStateFromProps(pageProps) {
    const transientState = (0, libs_next_utils_1.createPagePropGetter)(SearchState_shared_1.SEARCH_STATE_PROP)(pageProps);
    if (!transientState)
        return null;
    const { searchQuery, searchTime, state } = transientState;
    return {
        searchQuery,
        searchTime,
        state: (0, superjson_1.deserialize)(state),
    };
}
exports.getSearchStateFromProps = getSearchStateFromProps;
function useFirstRender() {
    const firstRenderRef = (0, react_1.useRef)(true);
    const firstRender = firstRenderRef.current;
    firstRenderRef.current = false;
    return firstRender;
}
function withSearchStatePageContext(options) {
    return function wrapSearchStatePage(PageComponent) {
        function WithSearchStatePage(pageProps) {
            const firstRender = useFirstRender();
            const { replace, push } = (0, router_1.useRouter)();
            const { urlQuery, mapUrlQueryResultToInternalLink, mapPageStateToUrlQueryVariables, withHistorySaved, } = options;
            const { state: queryState, searchQuery, searchTime, } = getSearchStateFromProps(pageProps);
            // const [searchQuery, setSearchQuery] = useState<string | undefined>(
            //   serverSearchQuery
            // );
            const [state, set] = (0, react_1.useState)(queryState);
            const prevState = (0, react_1.useRef)(state);
            const subscriptions = (0, react_1.useRef)([]);
            (0, react_1.useEffect)(function updateSearchStateOnQueryChange() {
                if (firstRender)
                    return;
                prevState.current = state;
                set(queryState);
                subscriptions.current.forEach(subscription => {
                    subscription(queryState, prevState.current);
                });
            }, 
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [searchQuery, searchTime]);
            const [getUrl] = (0, libs_context_req_ctx_1.useLazyQuery)(urlQuery, {
                onCompleted: urlData => {
                    const url = mapUrlQueryResultToInternalLink(urlData);
                    const { as, href, locale = null } = (0, libs_router_link_utils_1.getTargetPageData)(url);
                    const routerMethod = withHistorySaved ? push : replace;
                    routerMethod(href, as, {
                        locale,
                        shallow: true,
                        scroll: false,
                    });
                },
                // fetchPolicy: 'cache-and-network',
            });
            // @TODO implement updating history href/as and load new data
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function updateSearchQuery(nextQuery) {
                // setSearchQuery(nextQuery);
                // eslint-disable-next-line no-console
                console.warn(`updateSearchQuery is not yet implemented`);
            }
            const triggerUrlChange = (0, react_1.useCallback)((currentState) => {
                getUrl({
                    variables: mapPageStateToUrlQueryVariables(currentState, pageProps),
                });
            }, 
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [getUrl]);
            function setState(nextState, cb) {
                set(prev => {
                    let next;
                    if (nextState instanceof Function) {
                        next = nextState(prev);
                    }
                    else {
                        next = nextState;
                    }
                    cb === null || cb === void 0 ? void 0 : cb(next);
                    return next;
                });
            }
            (0, react_1.useEffect)(() => {
                if (firstRender || !state)
                    return;
                triggerUrlChange(state);
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [state]);
            const subscribe = (0, react_1.useCallback)(callback => {
                if (subscriptions.current.indexOf(callback) === -1) {
                    subscriptions.current.push(callback);
                }
                return () => {
                    subscriptions.current.splice(subscriptions.current.indexOf(callback), 1);
                };
            }, []);
            const ctx = (0, react_1.useMemo)(() => {
                return {
                    state,
                    searchQuery,
                    loading: false,
                    setState,
                    updateSearchQuery,
                    subscribe,
                };
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [state, searchQuery]);
            return (react_1.default.createElement(SearchStateContext_1.SearchStateContext.Provider, { value: ctx },
                react_1.default.createElement(PageComponent, Object.assign({}, pageProps))));
        }
        (0, hoist_non_react_statics_1.default)(WithSearchStatePage, PageComponent);
        return WithSearchStatePage;
    };
}
exports.withSearchStatePageContext = withSearchStatePageContext;
function useSearchState() {
    return (0, react_1.useContext)(SearchStateContext_1.SearchStateContext);
}
exports.useSearchState = useSearchState;
function useOnSearchStateChanges(callback) {
    const callbackRef = (0, react_1.useRef)(callback);
    callbackRef.current = callback;
    const { subscribe } = useSearchState();
    (0, react_1.useEffect)(() => {
        function currentCallback(next, prev) {
            var _a;
            (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, next, prev);
        }
        return subscribe(currentCallback);
    }, [subscribe]);
}
exports.useOnSearchStateChanges = useOnSearchStateChanges;
//# sourceMappingURL=withSearchStatePageContext.js.map